import { IconArrowDown, IconArrowUp, IconPoint } from '@tabler/icons-react'
import Stat from '../../stories/Stat/Stat'

interface MatchRankDisplayProps {
  leagueRank: number | null | undefined
  leagueRankChange: number | null | undefined
}

export default function MatchRankDisplay({
  leagueRank,
  leagueRankChange,
}: MatchRankDisplayProps) {
  const getRankChangeIcon = (change: number) => {
    if (change > 0) return IconArrowUp
    if (change < 0) return IconArrowDown
    return IconPoint
  }

  const getRankChangeColor = (change: number) => {
    if (change > 0) return 'green'
    if (change < 0) return 'red'
    return 'gray'
  }

  return (
    <Stat
      title="League Position"
      value={leagueRank ?? null}
      icon={getRankChangeIcon(leagueRankChange ?? 0)}
      iconColor={getRankChangeColor(leagueRankChange ?? 0)}
      isValueSub
      isTeamHeader
      background="white"
    />
  )
}
